import React, { useContext } from 'react'
import { t } from 'i18next'
import { Input, Select } from 'antd'
import GlobalContext from '../GlobalContext'

const LEVELS = ['operation', 'maintenance', 'error', 'stopped', 'unknow']
const ONLINE = [true, false]

export default function BoxFilter ({ filter, onChangeFilter }) {
  const { owners } = useContext(GlobalContext)

  const onChange = (hash) => {
    onChangeFilter({ ...filter, ...hash })
  }
  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <Input
        style={{ width: '150px' }}
        onChange={(e) => { onChange({ name: e.target.value }) }} placeholder={t('Admin.BoxFilter.name')}
        value={filter.name}
      />
      <Input
        style={{ width: '150px' }}
        onChange={(e) => { onChange({ zip_code: e.target.value }) }} placeholder={t('Admin.BoxFilter.zipCode')}
        value={filter.zip_code}
      />
      <Select
        showSearch={{
          optionFilterProp: 'children',
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }}
        allowClear={true}
        placeholder={t('Admin.BoxFilter.owner')}
        onChange={(value) => onChange({ owner_id: value || '' })}
        options={owners?.map((o) => ({ label: o.name, value: o.id })) || []}
      />
      <Select
        showSearch={{
          optionFilterProp: 'children',
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }}
        allowClear={true}
        placeholder={t('Admin.BoxFilter.level')}
        style={{ width: '200px' }}
        onChange={(value) => onChange({ level: value || 'all' })}
        options={LEVELS.map((level) => ({ label: t(`Admin.Box.level.${level}`), value: level }))}
      />
      <Select
        showSearch={{
          optionFilterProp: 'children',
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }}
        allowClear={true}
        placeholder={t('Admin.BoxFilter.online')}
        style={{ width: '200px' }}
        onChange={(value) => {
          value = value === undefined ? 'all' : value
          onChange({ online: value })
        }}
        options={ONLINE.map((online) => ({ label: t(`Admin.Box.online.${online}`), value: online }))}
      />
    </div>
  )
}
